import { GET_BIKE_VARIANTS_REQUEST, GET_BIKE_VARIANTS_SUCCESS, GET_BIKE_VARIANTS_FAILURE } from '../constants/get_bike_variants.constants';

export const getBikeVariantsRequest = params => ({
    type: GET_BIKE_VARIANTS_REQUEST,
    params,
});

export const getBikeVariantsSuccess = payload => ({
    type: GET_BIKE_VARIANTS_SUCCESS, payload,
});

export const getBikeVariantsFailure = error => ({
    type: GET_BIKE_VARIANTS_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/get_bike_variants.actions.js